export default __webpack_public_path__ + "static/hero-bg-da3e2c0b00bbfc698e62c9deafcf96ea.png";